import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { Suspense, useMemo, useState } from 'react'
import { Outlet } from 'react-router'

export type ApplicationsOutletContext = {
  view: 'cards' | 'table'
  setView: (view: 'cards' | 'table') => void
}

export const ApplicationsRootLayout = () => {
  const [view, setView] = useState<'cards' | 'table'>('table')
  const outletContext: ApplicationsOutletContext = useMemo(
    () => ({
      view,
      setView,
    }),
    [view]
  )
  return (
    <Suspense fallback={<LoadingComponent />}>
      <Outlet context={outletContext} />
    </Suspense>
  )
}
